import { render, staticRenderFns } from "./GuestsOverview.vue?vue&type=template&id=31a2552d"
import script from "./GuestsOverview.vue?vue&type=script&lang=js"
export * from "./GuestsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports